import { forwardRef, useEffect, useState } from "react";
import { Wrapper } from "./styles";
import type { APITypes } from "plyr-react";

// Type for PlyrComponent
type PlyrComponentType = React.ComponentType<any>;

type Props = {
  className?: string;
  src: string;
  poster: string;
};

const VideoPlayer = forwardRef<APITypes, Props>(function VideoPlayer(
  props,
  ref
) {
  const { className, src, poster } = props;
  const [PlyrComponent, setPlyrComponent] = useState<PlyrComponentType | null>(
    null
  );

  useEffect(() => {
    // Import PlyrComponent only on client side to avoid SSR issues
    if (typeof window !== "undefined") {
      import("plyr-react").then((mod) => {
        setPlyrComponent(() => mod.default as any);
      });
    }
  }, []);

  if (!PlyrComponent) {
    return (
      <Wrapper className={className}>
        <div style={{ width: "100%", height: "100%", minHeight: "200px" }} />
      </Wrapper>
    );
  }

  return (
    <Wrapper className={className}>
      <PlyrComponent
        ref={ref}
        source={{
          type: "video",
          poster,
          sources: [
            {
              src,
            },
          ],
        }}
        options={{
          controls: ["play", "play-large", "progress", "mute", "volume"],
          fullscreen: { enabled: false },
          iconUrl: "/plyr.svg",
        }}
      />
    </Wrapper>
  );
});

export default VideoPlayer;
